import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga4';
import axios from "axios"
import { Auth } from "aws-amplify";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AlertTitle, CircularProgress, Divider, List, ListItem } from "@mui/material";
import { useTranslation } from 'react-i18next';

import MuiAlert from '@mui/material/Alert';

import Dashboard from "./Dashboard";
import Region from "./Region";
import School from "./School";
import Report from "./Report";
// import Test from "./Test";

// Custom hook to log page views on route changes
function usePageView() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      user: "Super Admin",
      // product_id: productId, // Assuming productId is a variable
    });
    // console.log(window.location.pathname)
  }, [location]);
}

const Content = () => {
  usePageView()

  const [superAdminInfo, setSuperAdminInfo] = useState("")
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState([])

  const { t } = useTranslation();

  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      const cognitoUsername = data.idToken.payload["cognito:username"];
      
      const getSuperAdminInfo = async() => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/superAdmin/"+cognitoUsername, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': jwtToken
            }
          });
          // console.log(response.data)
          if(response.data.test.lang){
            setSuperAdminInfo(response.data)
          }
          else{
            setError(true)
            setErrorMsg(["LANG_NOT_FOUND", "Latest Test does not contain any languages"])
          }
        }
        catch (error) {
          setError(true)
          setErrorMsg([error.code, error.message])
          console.log(error)
        }
      }

      getSuperAdminInfo()
    })
    .catch((err) => console.log(err));
    
  }, []);

  return (
    <div className="content">
      {superAdminInfo
        ?
        <>
          {superAdminInfo.notification && 
            <div style={{display: "flex", backgroundColor: "rgb(255, 244, 229)", padding: "6px 12px", borderRadius: "6px"}}>
              <p style={{fontSize: "14px", color: "rgb(102, 60, 0)"}}> <b>Info:</b> {superAdminInfo.notification}</p>
            </div>
          }
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/region" element={<Region superAdminInfo={superAdminInfo}/>} />
            <Route path="/school" element={<School superAdminInfo={superAdminInfo}/>} />
            <Route path="/results" element={<Report superAdminInfo={superAdminInfo}/>} />
            {/* <Route path="/test" element={<Test superAdminInfo={superAdminInfo}/>} /> */}
            <Route path="*" element={<Navigate to="/" replace/>} />
          </Routes>
        </>
        :
        <div className="blankScreen">
          {error 
            ?
            <MuiAlert severity="warning" className="blankScreenError" sx={{borderRadius: "10px"}}>
              <AlertTitle><h3>{t("commonItems.error_network_label")}:</h3></AlertTitle>
                <Divider/>
                <List>
                  <ListItem disableGutters><h3>{t("commonItems.error_network_line1")}</h3></ListItem>
                  <ListItem disableGutters>
                    <p>{t("commonItems.error_network_line2")} <span></span>
                      <a href="https://forms.gle/fnU48UpGWWs5zgoT6" target="_blank" rel="noopener noreferrer" style={{color: "rgb(25, 118, 210)", textDecoration: "underline", textUnderlinePosition: "under"}}>
                        {t("commonItems.error_network_line2_formLinkLabel")}
                      </a>
                    </p>
                    </ListItem>
                  {errorMsg && 
                    <ListItem disableGutters>
                      <p>
                        {t("commonItems.error_network_response", {code: errorMsg[0], msg: errorMsg[1]})}
                      </p>
                    </ListItem>
                  }
                </List>
            </MuiAlert>
            :
            <CircularProgress color="info"/>
          }
        </div>
      }
    </div>
  )
};

export default Content;
